import { useMutation } from '@tanstack/react-query';
import { getAllProjects } from "@/api/project"; 
import { GetAllProjectsData, Project } from "@/types/project"; 
import { PostParam } from "@/types/index"; 

export function useGetAllProjects(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<Project[], Error, GetAllProjectsData>({
    mutationFn: getAllProjects,
    onSuccess,
    onError
  });
}